import React from 'react';

import { ContentActionsService } from '~commonInfra/contentActions/ContentActions';
import { Messages } from '~src/codegen/Localize';
import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';
import { RemoteQueryAgentHelper } from '~src/datasource/ServerApi/requests/RemoteQueryAgentHelper';
import { ContentDetailSection, DetailEditButton } from '~src/spacesPlatform/components/content/contentDetailDialog/ContentDetailSection';


/** THIS SECTION IS USED FOR DEBUGGING ONLY. NOT CUSTOMER FACING **/
interface RemoteQueryAgentDetailSectionOwnProps {
  readonly datasource: IDataSourceDetailInfo;
}

export function RemoteQueryAgentDetailSection(props: RemoteQueryAgentDetailSectionOwnProps): JSX.Element {

  const changeRemoteQueryAgent = () => {
    return ContentActionsService.changeRemoteQueryAgentOnDatasource(props.datasource);
  };

  return (
    <ContentDetailSection
      header={Messages.datasourceRemoteQueryAgent()}
      testId={'remote-query-agent'}
      detail={RemoteQueryAgentHelper.getRemoteQueryAgentDisplayName(props.datasource)}
      isActionAllowed={true}
      action={<DetailEditButton
        buttonLabel={Messages.editDatasourceRemoteQueryAgent_action()}
        buttonTestId={'change-remote-query-agent'}
        onClickAction={changeRemoteQueryAgent}
      />}
    />);
}
